var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMatchLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 1.33334H9.33329M7.99996 9.33334L9.99996 7.33334M13.3333 9.33334C13.3333 12.2789 10.9455 14.6667 7.99996 14.6667C5.05444 14.6667 2.66663 12.2789 2.66663 9.33334C2.66663 6.38782 5.05444 4.00001 7.99996 4.00001C10.9455 4.00001 13.3333 6.38782 13.3333 9.33334Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMatchLogs);
export default __webpack_public_path__ + "static/media/sidebar-match-logs.73d6e1671845b055aa0557b67a6da187.svg";
export { ForwardRef as ReactComponent };